// extracted by mini-css-extract-plugin
export default {"incoming_tasks_wrapper":"IncomingTasks_incoming_tasks_wrapper__Dbf8Z"};